import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../../hooks/useSession";
import { useStates } from "../../../hooks/useStates";
import { useGeo } from "../../../hooks/useGeo";
import urls from "../../../config/urls.json";
import { isCap } from "../../../services/validators";
import { ApiService as api } from "../../../services/ApiService";
import { getYMD } from "../../../services/formatters";
import moment from "moment";
import { useEditAppointment } from "../../../hooks/useEditAppointment";
import { useExternalParams } from "../../../hooks/useExternalParams";
import { isProd } from "../../../services/env";
import { useDynatrace } from "../../../hooks/useDynatrace";
import useLog from "../../../hooks/useLog";

window.searchTimeout = null;

export const useLuogoPage = () => {
    const navigate = useNavigate();
    const {addressSearchEvent} = useLog();
    const { read, update, batchUpdate, isCompassQuintoSite } = useSession();
    const { searchAutocomplete, geolocalize, geoCode, geoDecode } = useGeo();
    const { states, setCurrentState, isFilialiPageReady, isFetchFilialiStart, isFetchFilialiWaiting, isFetchPositioEnd, isFetchPositioStart } = useStates();
    const { showModal, closeModal, askForEditAppointment } = useEditAppointment();

    const [suggestions, setSuggestions] = useState([]);
    const [fetchError, setFetchError] = useState(false);
    const [fetchErrorMessage, setFetchErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [soloInfo, setSoloInfo] = useState("");

    // from useLoading
    const { handleExternalParams } = useExternalParams();

    useEffect(() => {
        update("luogo", "");
        setCurrentState(states.CHECK_EXT_PARAMS_START);
        checkForExternalParams();
    }, []);

    const {} = useDynatrace();

    const setPrestitoBusiness = () => {
        update("prodotto", 5);
        navigate(urls.prestitoBusiness.path);
    };

    const checkForExternalParams = async () => {
        const extParamsResultCallback = await handleExternalParams();
        if (extParamsResultCallback) {
            await extParamsResultCallback();
            return;
        }

        setCurrentState(states.CHECK_EXT_PARAMS_END);
        // const url = urls.luogo.path;
        // navigate(url, { replace: true });
        if (read("oppID_external")) {
            askForEditAppointment();
        }
        setIsLoading(false);
    };

    // useEffect(() => {
    // }, []);

    const next = () => {
        if (isFilialiPageReady()) {
            window.dataLayer.push({
                event: "presa_info_fa",
                eventCategory: "Fissa Appuntamento",
                eventAction: "Presa informazioni",
                eventLabel: read("solo_info"),
            });
            navigate(urls.filialiC5.path);
        } else {
            setCurrentState(states.FETCH_FILIALI_WAITING);
        }
    };

    const nextPP = async () => {
        if (isFilialiPageReady()) {
            window.dataLayer.push({
                event: "presa_info_fa",
                eventCategory: "Fissa Appuntamento",
                eventAction: "Presa informazioni",
                eventLabel: read("solo_info"),
            });

            if (isCompassQuintoSite()) {
                try {
                    const tokenEncodeRes = await api.TokenB2BEncode({
                        firstName: read("nome"),
                        lastName: read("cognome"),
                        email: read("email"),
                        mobilePhone: read("cellulare"),
                        fiscalCode: read("codiceFiscale"),
                    });
                    if (tokenEncodeRes) {
                        window.location.href = `${isProd() ? "https://compass.it" : "https://compass-col.int.compassonline.it"}/fa3?token=${tokenEncodeRes.token}&AppCode=FAC5&isB2B=true`;
                    }
                } catch (error) {
                    console.log(error);
                }
            } else {
                navigate(urls.filiali.path);
            }
        } else {
            setCurrentState(states.FETCH_FILIALI_WAITING);
        }
    };

    const onGeoClick = async () => {
        setSuggestions([]);

        setCurrentState(states.FETCH_POSITION_START);
        const geoResult = await geolocalize();
        update("luogo", geoResult.address);

        // we also need cap for TrovaFiliali3
        let decodeGeoResult = {};
        try {
            decodeGeoResult = await geoDecode(geoResult.coords);
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
            setFetchError(true);
            return;
        }

        update("cap", decodeGeoResult.postCode);

        _onInputReceived(geoResult.coords);
    };

    const setPrestitoPersonale = () => {
        update("prodotto", 1);
        navigate(urls.luogo.path);
    };

    const _onInputReceived = async (coords = null, suggestionCoords = null) => {
        update("placeType", "");

        let coordinate = coords;

        if (null == coordinate) {
            setCurrentState(states.FETCH_POSITION_START);
            const searchString = read("luogo");
            // 1. ottenere le coordinate
            // if (isCap(searchString)) {
            //     // se cap -> translatecaptocoords
            //     try {
            //         coordinate = await api.getCoordsByCap(searchString);
            //     } catch (error) {
            //         setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
            //         setFetchError(true);
            //         return;
            //     }
            //     update("cap", searchString);
            // } else {
            // se non cap -> geocode [cap ok]
            try {
                // coordinate = await geoCode(searchString);
                coordinate = await geoDecode(suggestionCoords || { lat: coordinate.lat, lng: coordinate.lng });
                if (coordinate.address.toLowerCase() == "italia") throw new Error();
            } catch (error) {
                if (!isProd()) console.log("error");
                // setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
                // setFetchError(true);
                setCurrentState(states.FETCH_POSITION_ERROR);
                return;
            }

            // test
            // if (!coordinate.cap) {
            //     const res = await geoDecode(suggestionCoords || { lat: coordinate.lat, lng: coordinate.lng });
            //     coordinate.cap = res.postCode;
            //     update("placeType", "LOCALITY");
            // }
            //-- test

            update("cap", coordinate.cap || coordinate.city);
            update("placeType", coordinate.placeType);

            if (!read("luogo").match(/ Italia$/)) {
                update("luogo", coordinate.address);
            }
            // }
        }
        setCurrentState(states.FETCH_POSITION_END);

        // 2. trovafiliali con coordinate e cap (?)
        setCurrentState(states.FETCH_FILIALI_START);

        // logs
        update("log_lat", coordinate.lat)
        update("log_lon", coordinate.lng)
        update("log_zip", read("cap"));

        let filialiResult = {};
        try {
            filialiResult = await api.TrovaFilialiC5({
                latitude: coordinate.lat,
                longitude: coordinate.lng,
                cap: read("cap"),
                placeType: read("placeType") || "",
            });
        } catch (error) {
            setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
            setFetchError(true);
            return;
        }

        update("log_filiali", filialiResult.filiali ? filialiResult.filiali.map(f => f.codFiliale) : filialiResult.map(f => f.CodiceOcsPV));
        // let's call the log service right here, we should have all the info at this point
        addressSearchEvent();

        if (filialiResult.isPP === true) {
            //Non c'erano filiali c5 disponibili, rimando a PP
            batchUpdate({
                filiali: filialiResult.filiali,
                filialeScelta: filialiResult.filiali[0],
                disponibilita: filialiResult.filiali[0].days,
                dataScelta: filialiResult.filiali[0].days[0],
                ricontattoLuogo: filialiResult.ricontatto,
                prodotto: 1,
            });
            let disponibilitaResult = {};
            try {
                disponibilitaResult = await api.Disponibilita({
                    CodFiliale: read("filiali")[0].codFiliale,
                    Giorno: getYMD(read("filiali")[0].days[0].data),
                });
            } catch (error) {
                setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
                setFetchError(true);
                return;
            }

            batchUpdate({
                orari: disponibilitaResult.orariDisponibili,
                orarioScelto: disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0],
            });

            // 1. we need it to make sure we automagically call "next" if user
            //    clicked before filiali were actually fetched
            const previousState = read("state");
            setCurrentState(states.FETCH_FILIALI_END);
            return;
        }

        filialiResult = filialiResult.map((f) => {
            return {
                cap: f.CAPUfficio,
                citta: f.CittaUfficio,
                codFiliale: f.CodiceOcsPV,
                coordinate: {
                    lat: f.Latitudine,
                    lng: f.Longitudine,
                },
                indirizzo: f.IndirizzoUfficio,
                nomeFiliale: f.RagioneSociale,
                provincia: f.ProvinciaUfficio,
            };
        });

        // update("filiali", filialiResult.filiali);
        // update("filialeScelta", filialiResult.filiali[0]);
        // update("disponibilita", filialiResult.filiali[0].days);
        // update("dataScelta", filialiResult.filiali[0].days[0]);
        // update("ricontattoLuogo", filialiResult.ricontatto);

        const filiali = filialiResult;
        const prom = [];
        for (let f in filiali) {
            const filiale = filiali[f];
            prom.push(
                api.GetDayAndTimeSlot({
                    IdFiliale: filiale.codFiliale,
                    From: moment().toDate(),
                    To: moment().add(7, "days").toDate(),
                })
            );
        }

        try {
            const listaDisponibilitaResult = await Promise.all(prom);
            for (let d in listaDisponibilitaResult) {
                //Lista giorni disponibili per singola filiale
                const giornoDisponibilitaResult = listaDisponibilitaResult[d];
                let disponibilita = giornoDisponibilitaResult.Slots || [];
                if (d == 0 && disponibilita.length == 0) {
                    disponibilita = [
                        {
                            Date: moment().format(),
                            Time: [],
                        },
                    ];
                }
                for (let ds in disponibilita) {
                    const disp = disponibilita[ds];
                    if (d == 0) {
                        //Impostiamo la disponibilita per il primo giorno
                        const orari = [
                            { hour: 9, minute: 0, disponibile: false },
                            { hour: 9, minute: 30, disponibile: false },
                            { hour: 10, minute: 0, disponibile: false },
                            { hour: 10, minute: 30, disponibile: false },
                            { hour: 11, minute: 0, disponibile: false },
                            { hour: 11, minute: 30, disponibile: false },
                            { hour: 12, minute: 0, disponibile: false },
                            { hour: 12, minute: 30, disponibile: false },
                            { hour: 14, minute: 0, disponibile: false },
                            { hour: 14, minute: 30, disponibile: false },
                            { hour: 15, minute: 0, disponibile: false },
                            { hour: 15, minute: 30, disponibile: false },
                            { hour: 16, minute: 0, disponibile: false },
                            { hour: 16, minute: 30, disponibile: false },
                            { hour: 17, minute: 0, disponibile: false },
                            { hour: 17, minute: 30, disponibile: false },
                        ];
                        let primoDisponibile = null;
                        for (let t in disp.Time) {
                            const orarioDisponibile = disp.Time[t];
                            const ora = orarioDisponibile.split(":")[0];
                            const minuto = orarioDisponibile.split(":")[1];
                            for (let o in orari) {
                                if (orari[o].hour == ora && orari[o].minute == minuto) {
                                    orari[o].disponibile = true;
                                    if (primoDisponibile == null) {
                                        primoDisponibile = orari[o];
                                    }
                                }
                            }
                        }
                        batchUpdate({
                            orari: orari,
                            orarioScelto: primoDisponibile,
                        });
                    }
                    if (!filiali[d].hasOwnProperty("days")) {
                        filiali[d].days = [];
                    }
                    if (disp != "KO") {
                        filiali[d].days.push({
                            data: disp.Date,
                            disponibilita: null,
                        });
                    }
                }
            }
        } catch (err) {
            if (!isProd()) console.log(err);
        }

        batchUpdate({
            filiali: filiali,
            filialeScelta: filiali[0],
            disponibilita: filiali[0].days,
        });

        // 3. chiedere disponibilita per prima filiale e primo giorno
        /*let disponibilitaResult = {};
    try {
      disponibilitaResult = await api.Disponibilita({
        CodFiliale: read("filiali")[0].CodiceOcsPV,
        Giorno: getYMD(read("filiali")[0].days[0].data),
      });
    } catch (error) {
      setFetchErrorMessage("C'è stato un errore nella ricerca delle filiali. <br />Per favore riprova.");
      setFetchError(true);
      return;
    }

    // update("orari", disponibilitaResult.orariDisponibili);
    // update("orarioScelto", disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0]);
    batchUpdate({
      orari: disponibilitaResult.orariDisponibili,
      orarioScelto: disponibilitaResult.orariDisponibili.filter((_) => _.disponibile == true)[0],
    });*/

        // 1. we need it to make sure we automagically call "next" if user
        //    clicked before filiali were actually fetched
        const previousState = read("state");

        setCurrentState(states.FETCH_FILIALI_END);

        // 2. now call automagically
        if (previousState == states.FETCH_FILIALI_WAITING) next();
    };

    const onLuogoChange = async (value) => {
        window.clearTimeout(window.searchTimeout);

        setCurrentState(states.BUSY);
        update("luogo", value);
        // logs
        update("log_search", value);

        if (value.length <= 3) {
            setSuggestions([]);
        } else {
            window.searchTimeout = window.setTimeout(async () => {
                const suggestions = await searchAutocomplete(value);
                // console.log("asd");
                setSuggestions(suggestions);
            }, 2000);
        }
    };
    const onLuogoBlur = () => {
        setTimeout(() => {
            if (read("state") >= states.FETCH_POSITION_START) return;

            if (read("luogo").replaceAll(" ", "").length == 0) return;
            _onInputReceived();
            // setSuggestions([]);
        }, 250);
    };
    const onSuggestionClick = (itm, idx) => {
        if (!itm) itm = suggestions.length ? suggestions[0] : null;
        if (!itm) return;
        update("luogo", getSuggestionText(itm));
        
        // logs
        update("log_selected", getSuggestionText(itm));
        update("log_addr_pos", idx || 0);

        _onInputReceived(null, { lat: itm.coordinate.latitude, lng: itm.coordinate.longitude });
        setSuggestions([]);
    };
    const getSuggestionText = (itm) => {
        return itm.displayLines.join(", ");
    };

    const getSearchInputState = () => {
        return isFetchPositioStart() ? 2 : isFetchPositioEnd() ? 3 : 1;
    };

    return {
        read,
        update,
        next,
        nextPP,
        onLuogoChange,
        onLuogoBlur,
        onSuggestionClick,
        getSuggestionText,
        suggestions,
        setSuggestions,
        onGeoClick,
        isFilialiPageReady,
        isFetchFilialiStart,
        isFetchFilialiWaiting,
        isFetchPositioEnd,
        isFetchPositioStart,
        getSearchInputState,
        fetchErrorMessage,
        fetchError,
        setFetchError,
        showModal,
        closeModal,
        askForEditAppointment,
        isLoading,
        setSoloInfo,
        setPrestitoBusiness,
        setPrestitoPersonale,
    };
};
